import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFirebaseAuth } from '../auth/FirebaseAuthContext';
import { usePostAuthProvision } from '../auth/usePostAuthProvision';

/**
 * Post-authentication landing used by the OAuth flow. Runs the same idempotent
 * backend provisioning (Mongo user + Stripe customer) and PostHog identify that
 * the email/password screens do inline, then forwards to the workspace.
 */
export function PostAuth() {
  const { user, isLoaded } = useFirebaseAuth();
  const provisionAfterAuth = usePostAuthProvision();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (!isLoaded) return;
    if (!user) {
      navigate('/sign-in', { replace: true });
      return;
    }
    if (ran.current) return;
    ran.current = true;

    (async () => {
      await provisionAfterAuth();
      navigate('/workspace', { replace: true });
    })();
  }, [isLoaded, user, provisionAfterAuth, navigate]);

  return (
    <main
      className={`
        bg-gray-25 flex min-h-screen items-center justify-center font-[Outfit]
        text-gray-500
      `}
    >
      <p>Finishing sign-in…</p>
    </main>
  );
}
